import React from "react";
import {
  PencilSimple,
  Hourglass,
  BookmarkSimple,
  Check,
  ChatDots,
  WarningCircle,
} from "phosphor-react";
import { Circle, Label } from "@networkraildigitalfactory/components";

const StatusLabel = (props) => {
  const { status } = props;
  const getIcon = () => {
    let icon;
    switch (status) {
      case "Editing":
        icon = <PencilSimple size={16} color="white" weight="fill" />;
        break;
      case "Pending approval":
      case "In progress":
        icon = <Hourglass size={16} color="white" weight="fill" />;
        break;
      case "Draft":
        icon = <BookmarkSimple size={16} color="white" weight="fill" />;
        break;
      case "New comments":
        icon = <ChatDots size={16} color="white" weight="fill" />;

        break;
      case "Submitted":
      case "Approved":
      case "Cancelled":
      case "Completed":
      case "Closed":
      case "Employee complete":
      case "Prep complete":
        icon = <Check size={20} color="white" weight="bold" />;
        break;
      case "Review required":
      case "New":
        icon = <WarningCircle size={26} color="#37519D" weight="fill" />;
        break;
      default:
        icon = null;
        break;
    }
    return icon;
  };

  const renderIcon = () => {
    if (status === "New" || status === "Review required") {
      return getIcon();
    }
    return (
      <Circle size={24} color="#37519D">
        {getIcon()}
      </Circle>
    );
  };

  return (
    <Label style={{ display: "flex", alignSelf: "flex-end" }}>
      <span style={{ marginRight: "10px" }}>{status}</span>
      {renderIcon()}
    </Label>
  );
};

export default StatusLabel;
